var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { goBack } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { addKey } from '@popup/steem/actions/account.actions';
import { refreshActiveAccount } from '@popup/steem/actions/active-account.actions';
import AccountUtils from '@popup/steem/utils/account.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import ArrayUtils from 'src/utils/array.utils';
const AddKey = ({ keyType, activeAccountName, activeAccount, localAccounts, mk, addKey, setTitleContainerProperties, setErrorMessage, refreshActiveAccount, setSuccessMessage, goBack, }) => {
    const [privateKey, setPrivateKey] = useState('');
    const [availableAuths, setAvailableAuths] = useState([]);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_add_key',
            isBackButtonEnabled: true,
        });
        loadAuthorizedAccounts();
    }, []);
    const importKey = () => __awaiter(void 0, void 0, void 0, function* () {
        if (privateKey.trim().length === 0) {
            setErrorMessage('popup_accounts_fill');
            return;
        }
        addKey(privateKey.trim(), keyType, setErrorMessage);
        goBack();
    });
    const loadAuthorizedAccounts = () => __awaiter(void 0, void 0, void 0, function* () {
        activeAccount.account.posting;
        const auths = activeAccount.account[keyType.toLowerCase()].account_auths.map((auth) => auth[0]);
        setAvailableAuths(ArrayUtils.findCommons(auths, localAccounts.map((la) => la.name)));
    });
    const addAuth = (username) => __awaiter(void 0, void 0, void 0, function* () {
        yield AccountUtils.addAuthorizedKey(activeAccount, username, localAccounts, mk, keyType);
        refreshActiveAccount();
        setSuccessMessage('html_popup_successfully_add_key');
        goBack();
    });
    return (React.createElement("div", { className: "add-key-page", "data-testid": `${Screen.SETTINGS_ADD_KEY}-page` },
        React.createElement("div", { "data-testid": "add-key-page-paragraph-introduction", className: "caption", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_add_key_text', [
                    keyType.substring(0, 1) + keyType.substring(1).toLowerCase(),
                ]),
            } }),
        React.createElement(InputComponent, { dataTestId: "input-private-key", type: InputType.PASSWORD, placeholder: "popup_html_private_key", value: privateKey, onChange: setPrivateKey, onEnterPress: importKey }),
        availableAuths.length > 0 && (React.createElement("div", { className: "available-auths" },
            React.createElement("div", { className: "caption" }, getMessage('html_add_available_authorities_caption')),
            React.createElement("div", { className: "auths" }, availableAuths.map((auth, index) => (React.createElement("div", { className: "auth", key: `account-auth-item-${auth}-${index}` },
                React.createElement("div", { className: "item-account", onClick: () => addAuth(auth) },
                    React.createElement("img", { className: "account-img", src: `https://steemitimages.com/u/${auth}/avatar`, onError: (e) => {
                            e.target.onError = null;
                            e.target.src = '/assets/images/menu/accounts.svg';
                        } }),
                    React.createElement("div", { className: "account-name" }, auth)))))))),
        React.createElement("div", { className: "fill-space" }),
        React.createElement(ButtonComponent, { dataTestId: "import-keys-button", label: "popup_html_import_key", onClick: importKey })));
};
const mapStateToProps = (state) => {
    return {
        keyType: state.navigation.stack[0].params,
        activeAccountName: state.steem.activeAccount.name,
        activeAccount: state.steem.activeAccount,
        localAccounts: state.steem.accounts,
        mk: state.mk,
    };
};
const connector = connect(mapStateToProps, {
    goBack,
    addKey,
    setTitleContainerProperties,
    setErrorMessage,
    setSuccessMessage,
    refreshActiveAccount,
});
export const AddKeyComponent = connector(AddKey);
